import type { ActResult, RoomAction, RoomView } from "@shared/types";

export type RoomStatus = "connecting" | "live" | "reconnecting" | "gone";

/** One interface for online rooms (server over SSE) and local rooms (engine in the browser). */
export interface RoomClient {
  readonly code: string;
  readonly local: boolean;
  view(): RoomView | null;
  status(): RoomStatus;
  goneReason(): string | null;
  /** serverNow − Date.now(), to render server deadlines with the local clock */
  offset(): number;
  subscribe(fn: () => void): () => void;
  act(action: RoomAction): Promise<ActResult>;
  close(): void;
  /** Online rooms: this device's seat credentials (for game-specific uploads, e.g. Guess audio). */
  seatAuth?(): { playerId: string; token: string } | null;
  /** Local rooms only: see / act as another seat (pass-and-play). */
  viewAs?(playerId: string): RoomView;
  actAs?(playerId: string, action: RoomAction): Promise<ActResult>;
}

/** A tiny emitter shared by both implementations. */
export class Emitter {
  private subs = new Set<() => void>();
  subscribe(fn: () => void) {
    this.subs.add(fn);
    return () => {
      this.subs.delete(fn);
    };
  }
  emit() {
    for (const f of [...this.subs]) {
      try {
        f();
      } catch (e) {
        console.error(e);
      }
    }
  }
}
